<template>
    <v-alert type="info" variant="tonal" prominent border="start" class="mb-4">
        <v-row align="center">
            <v-col cols="12" sm="6">
                <div class="text-h6">
                    <v-icon class="mr-2">mdi-database-import</v-icon>
                    Importing: <strong>{{ title }}</strong>
                </div>
            </v-col>
            <v-col cols="12" sm="6" class="text-right">
                <v-btn :href="sampleCsvPath" download color="primary" variant="outlined" size="large">
                    <v-icon class="mr-2">mdi-download</v-icon>
                    Download Sample CSV
                </v-btn>
            </v-col>
        </v-row>
    </v-alert>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ImportPageBanner',

    props: {
        title: {
            type: String,
            required: true
        },
        sampleCsvPath: {
            type: String,
            required: true
        }
    }
});
</script>
